import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import CenterModal from "../UI/Modal/CenterModal";
import { setShowCallDisconnectedPopup } from "../../reducers/common-reducer";

const LastUserDisconnectPopup = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { showCallDisconnectedPopup } = useSelector((state) => state.commonReducer);

    const body = (
        <div className='cms-modal-text' data-testid='endCallDiconnectModalBody'>
            <h3 className='text-center'>{localisedValues?.call_disconnected}</h3>
        </div>
    );

    const footer = (
        <div
            className='end-call-confirmation-footer-btn button-inline more-space button-inline-tb-space d-flex align-items-center'
            data-testid='endCallDiconnectModalFooter'
        >
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => dispatch(setShowCallDisconnectedPopup(false))}>
                    <span className='btn-icon'>{localisedValues?.okay_initcap}</span>
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={showCallDisconnectedPopup}
            modalClass='default-modal modal-small end-call-confirmation-modal'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            body={body}
            footer={footer}
            footerClassName='end-call-confirmation-footer align-items-center'
            backdrop={"static"}
            keyboard={false}
        />
    );
};

export default LastUserDisconnectPopup;
